<div class="tw-flex tw-justify-between tw-items-end tw-gap-1">
  <div class="[&>*]:tw-mb-0 [&>*]:tw-text-main tw-flex tw-items-center tw-gap-1">
    <ng-content></ng-content>
  </div>
  <div class="tw-text-muted has-[button]:-tw-mb-1">
    <ng-content select="[slot=end]"></ng-content>
  </div>
</div>
